export const ACCOUNTS_PROMILES_REQUEST_OPEN_MODAL = "ACCOUNTS_PROMILES_REQUEST_OPEN_MODAL";
export const ACCOUNTS_PROMILES_REQUEST_REQUEST = "ACCOUNTS_PROMILES_REQUEST_REQUEST";
export const ACCOUNTS_PROMILES_REQUEST_RESULT = "ACCOUNTS_PROMILES_REQUEST_RESULT";